import createReactClass from "create-react-class";
import React from "react";
export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      necessariesItem: this.props.necessariesItem,
    };
  },
  onError() {
    var updated = this.state.necessariesItem;
    updated.thumbnail_image_url = "/images/ja2/img_noimage.gif";
    this.setState({
      necessariesItem: updated,
    });
  },
  render() {
    var timeAgo = this.state.necessariesItem.created_at_time_ago_format;
    var isUnread = this.state.necessariesItem.is_read === false;
    return (
      <li className="notif-2026__item-wrap">
        <a
          href={this.props.necessariesItem.url}
          id="necessaries-item"
          className={"notif-2026__item" + (isUnread ? " notif-2026__item--unread" : "")}
        >
          <div className="notif-2026__row">
            <div className="notif-2026__thumb-wrap">
              <img
                src={this.state.necessariesItem.thumbnail_image_url}
                onError={this.onError}
                className="notif-2026__thumb"
                alt=""
              />
            </div>
            <div className="notif-2026__body">
              <div className="notif-2026__title-row">
                {isUnread && <span className="notif-2026__dot" aria-hidden="true" />}
                <p
                  className="notif-2026__body-title"
                  dangerouslySetInnerHTML={{
                    __html: this.state.necessariesItem.title,
                  }}
                />
              </div>
              <p className="notif-2026__time">{timeAgo}</p>
            </div>
          </div>
        </a>
      </li>
    );
  },
});